import { createFileRoute } from "@tanstack/react-router"

import { loadDigestTuner } from "@/admin/digest-tuner/digest-tuner-data"
import { DigestTunerPage } from "@/admin/digest-tuner/page"
import { getTerminalHeadMeta, TERMINAL_TITLE } from "@/lib/terminal/metadata"

// A fresh list remounts the page, which restarts its replay.
const DigestTunerRoute = () => {
  const data = Route.useLoaderData()
  return <DigestTunerPage key={data.generatedAt} data={data} />
}

export const Route = createFileRoute(
  "/_terminalAdmin/terminal/admin/digest-tuner"
)({
  head: () => ({
    meta: getTerminalHeadMeta(`Digest tuner | ${TERMINAL_TITLE}`),
  }),
  loader: () => loadDigestTuner(),
  // Keep the list until the page is reloaded.
  staleTime: Infinity,
  pendingComponent: () => (
    <p className="text-muted-foreground text-sm">Loading Companies…</p>
  ),
  component: DigestTunerRoute,
})
